import { render } from "./px-status-badge.vue?vue&type=template&id=47f465c0&scoped=true&ts=true"
import script from "./px-status-badge.vue?vue&type=script&lang=ts"
export * from "./px-status-badge.vue?vue&type=script&lang=ts"

import "./px-status-badge.vue?vue&type=style&index=0&id=47f465c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f465c0"]])

export default __exports__